// PASSWORD
export const PASSWORD_MIN_LENGTH = 8
export const PASSWORD_MAX_LENGTH = 20

export const ERROR_PASSWORD_NOT_JUST_WHITESPACE =
  'Password cannot be just whitespace.'
export const ERROR_PASSWORD_MIN_LENGTH = `Too short, use at least ${PASSWORD_MIN_LENGTH} characters.`
export const ERROR_PASSWORD_MAX_LENGTH = `Password is too long. Use at most ${PASSWORD_MAX_LENGTH} characters. You typed {charsTyped} characters.`

// EMAIL
export const EMAIL_FORMAT = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/g

export const ERROR_EMAIL_NOT_JUST_WHITESPACE =
  'Email cannot be just whitespace.'
export const ERROR_EMAIL_INVALID_FORMAT = 'Email format is invalid.'
